jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


	   var $btn = $('#mz-backToTop');

		$btn.hide();

		function toggleBackToTop(){
			var scrollTop = $(window).scrollTop();
			var windowHeight = $(window).height();
			var docHeight = $(document).height();

			if (docHeight > windowHeight + 100) {
			if (scrollTop > 300) {
				$btn.fadeIn().addClass('is--show');
			} else {
				$btn.fadeOut().removeClass('is--show');
			}
			} else {
				$btn.hide().removeClass('is--show');
			}
		}

		toggleBackToTop();

		$(window).on('scroll', toggleBackToTop);

		$(window).on('resize', toggleBackToTop);

		$btn.on('click', function(e){
			e.preventDefault();
			$('html, body').animate({scrollTop: 0}, 500);
		});

});


